<template lang="pug">
div(style="box-shadow: initial")
  .files-area-body(v-if="filesExist(files)")
    .existing-file(
      v-for="file in files",
      :key="fileKey(file)",
      :class="{ 'existing-file--deleted': isFileDeleted(file) }"
    )
      q-icon.existing-file-delete-icon(
        v-if="canDeleteFile(file)",
        :name="isFileDeleted(file) ? 'undo' : 'close'",
        @click.stop.prevent="toggleFileDelete(file)"
      )
      .form-image(v-if="isImage(file)")
        a.file-link(v-if="file", :href="file.url", target="_blank", :link_title="file.file_name")
          img.file-image(:src="file.url")
          span.caption {{ cutFileName(file.file_name) }}

      .form-image(v-else)
        a.file-link(v-if="file", :href="file.url", target="_blank", :link_title="file.file_name")
          inline-svg.file-document(:src="require('../../../assets/icons/document.svg')")
          span.caption {{ cutFileName(file.file_name) }}
  .files-area-body(v-else)
    span -
</template>

<script>
export default {
  components: {},

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      files: this.parentData.files || [],
    };
  },

  computed: {
    canDelete() {
      return this.parentData.canDelete === true || this.parentData.canDelete === "true";
    },

    deletedFileIds() {
      return this.parentData.deletedFileIds || [];
    },
  },

  methods: {
    closeFilesModal() {
      this.$emit("close-files-modal");
    },

    isImage(value) {
      if (value) {
        return ["image/jpeg", "image/png", "image/webp", "image/gif"].includes(value.content_type);
      } else {
        return false;
      }
    },

    filesExist(files) {
      return files?.length > 0;
    },

    fileKey(file) {
      return this.fileId(file) || file?.url || file?.file_name;
    },

    fileId(file) {
      return file?.id ?? file?.file_id ?? file?.blob_id ?? file?.attachment_id;
    },

    canDeleteFile(file) {
      return this.canDelete && this.fileId(file) !== undefined && this.fileId(file) !== null;
    },

    isFileDeleted(file) {
      return this.deletedFileIds.includes(this.fileId(file));
    },

    toggleFileDelete(file) {
      this.$emit("toggle-file-delete", {
        ...file,
        id: this.fileId(file),
      });
    },

    cutFileName(name) {
      const fileType = name.match(/\.(\w+)$/)[0];
      return name?.length > 15 ? `${name.substring(0, 13)} ..${fileType}` : name;
    },
  },
};
</script>

<style lang="scss">
@import "../../../assets/styles/forms/fields/file";
</style>
